import React, {Component} from 'react'
import {Field} from 'redux-form'
import styles from './styles.module.scss'

class Input extends Component {
  static defaultProps = {
    component: 'input',
    autoFocus: false,
    autoFocusDelay: 500
  }

  componentDidMount() {
    const {autoFocus, autoFocusDelay} = this.props

    if (autoFocus && this.inputRef) {
      setTimeout(this.focus, autoFocusDelay)
    }
  }

  focus = () => this.inputRef.focus()
  setInputRef = (ref) => {
    this.inputRef = ref

    if (this.props.ref) {
      this.props.ref(ref)
    }
  }

  render() {
    const {className, ...props} = this.props

    delete props.autoFocus
    delete props.autoFocusDelay

    return (
      <div className={[className, styles.input].join(' ')}>
        <Field getInputRef={this.setInputRef} {...props}/>
      </div>
    )
  }
}

export {Input}